import customerService from '@/services/customer.js';

const initialState = () => {
	return {
		customers: [],
		dropdownCustomers: [],
		customer: {},
		selectedCustomer: {},
		searchParams: {
			name: '',
			orderBy: 'Name',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	};
};

const state = initialState();

export default {
	debug: false,
	namespaced: true,
	state,
	mutations: {
		SET_DROPDOWN_CUSTOMERS(state, customers) {
			state.dropdownCustomers = customers;
		},
		SET_CUSTOMERS(state, customers) {
			state.customers = customers;
		},
		SET_CUSTOMER(state, customer) {
			state.customer = customer;
		},
		SET_SELECTED_CUSTOMER(state, customer) {
			state.selectedCustomer = customer;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		RESET(state) {
			Object.assign(state, initialState());
		}
	},

	actions: {
		async getCustomer({ commit }, customerId) {
			return await customerService
				.getCustomer(customerId)
				.then(data => {
					commit('SET_CUSTOMER', data);
				})
				.catch(err => {
					console.log('Error getting customer: ', err);
				});
		},

		async getCustomers({ state, commit, dispatch, rootGetters }) {
			dispatch('appStore/setLoading', 1, { root: true });
			state.searchParams.companyId = rootGetters['user/getActiveCompany'].id;

			return await customerService
				.getCustomers(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_CUSTOMERS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getCustomers');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting customers: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async getCustomersByCustomParams({ dispatch }, params) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await customerService
				.getCustomers(params)
				.then(res => {
					dispatch('appStore/setLoading', -1, { root: true });

					return res;
				})
				.catch(err => {
					console.log(err);

					dispatch('appStore/setLoading', -1, { root: true });

					return err;
				});
		},

		setCustomer({ commit }, customer) {
			commit('SET_CUSTOMER', customer);
		},
		
		setCustomers({ commit}, customers) {
			commit('SET_CUSTOMERS', customers);
		},

		setSelectedCustomer({ commit }, customer) {
			commit('SET_SELECTED_CUSTOMER', customer);
		},

		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},

		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},

		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},

		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		customer: state => {
			return state.customer;
		},
		customers: state => {
			return state.customers;
		},
		dropdownCustomers: state => {
			return state.dropdownCustomers;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		},
		selectedCustomer: state => {
			return state.selectedCustomer;
		}
	}
};
